import React from 'react';

// a link: an email (mailto), http(s)://..., www.... or a bare domain with a known ending (sky360.co.il/orders) - never
// ending with a punctuation mark ("see https://x.com." -> the dot stays text). The known endings keep "file.ts" /
// "v1.2" as text. The email goes first, so "nir@sky-group.co.il" is one mailto link, not a link of its domain.
const TLDS = 'co\\.il|org\\.il|gov\\.il|ac\\.il|com|co|il|net|org|io|info|biz|app|travel|me|tv|ly|ai|uk|de|fr|ru|ge';
const LINK_BODY = `[^\\s<>"']*[^\\s<>"'.,;:!?)\\]]`;
const EMAIL = '[a-z0-9._%+-]+@(?:[a-z0-9-]+\\.)+[a-z]{2,}';
const URL_PATTERN = new RegExp(
  `(${EMAIL}|(?:https?:\\/\\/|www\\.)${LINK_BODY}|\\b(?:[a-z0-9-]+\\.)+(?:${TLDS})\\b(?:\\/${LINK_BODY})?)`,
  'gi'
);

/** the href of a matched link - mailto: for an email, https:// added when it was written without a scheme */
const toHref = (link: string) =>
  link.includes('@') && !/^https?:\/\//i.test(link)
    ? `mailto:${link}`
    : /^https?:\/\//i.test(link)
    ? link
    : `https://${link}`;

/**
 * Plain text with its links clickable - opened in a new tab. Only text nodes and <a> are rendered, never HTML from
 * the text, so a comment can't inject markup. Line breaks are kept (white-space: pre-wrap).
 */
const LinkifiedText: React.FC<{ text?: string | null; className?: string }> = ({ text, className }) => {
  if (!text) {
    return null;
  }
  const parts = text.split(URL_PATTERN);
  return (
    <span className={`linkified-text ${className || ''}`}>
      {parts.map((part, index) =>
        index % 2 === 1 ? (
          <a key={index} href={toHref(part)} target="_blank" rel="noopener noreferrer">
            {part}
          </a>
        ) : (
          <React.Fragment key={index}>{part}</React.Fragment>
        )
      )}
    </span>
  );
};

export default LinkifiedText;
